export default {
    name: "sendPrintApply",
    conditionData: '',
    mounted: function () {
        this.init();
    },
    data() {
        return {
            printApplyForm: {
                blId: null,
                type: null,
                applyOriginalNumber: null,
                applyCopyNumber: null,
                pid: null,
            },
            blData: [],
            printerData: [],
            isNumReadOnly: false,
            accountBalance: null,
            costMoney: null,
            checkResObject: {
                checkRes: null
            },
            checkResMessage: null,
            sendBillFeeCompanyName: null
        }
    },
    created() {
    },
    watch: {
        'printApplyForm.blId':{
            handler(){
                this.autoOriginal();
                // 2021-02-02 追加
                this.getBillCostInfo();
            }
        },
        'printApplyForm.type':{
            handler(){
                this.autoOriginal();
                // 2021-02-02 追加
                this.getBillCostInfo();
            }
        },
        'printApplyForm.pid':{
            handler(){
                
            }
        },
    },
    computed: {
        rules() {
            // const checkCollectPhone = (rule, value, callback) => {
            //     let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
            //     if (value == "") {
            //         callback(new Error(this.$t('p_postagedInfo.message.collectPhone')));
            //         //引入methods中封装的检查手机格式的方法
            //     } else if (!phoneReg.test(value)) {
            //         callback(new Error(this.$t('p_postagedInfo.message.errPhone')));
            //     } else {
            //         callback();
            //     }
            // };
            return {
                blId: [
                    {required: true, message: this.$t('s_printApplyManage.message.blNo'), trigger: 'blur'},
                ],
                type: [
                    {required: true, message: this.$t('s_printApplyManage.message.type'), trigger: 'blur'},
                ],
                applyOriginalNumber: [
                    {required: true, message: this.$t('s_printApplyManage.message.applyOriginalNumber'), trigger: 'change'}
                ],
                applyCopyNumber: [
                    {required: true, message: this.$t('s_printApplyManage.message.applyCopyNumber'), trigger: 'blur'}
                ],
                pid: [
                    {required: true, message: this.$t('s_printApplyManage.message.printer'), trigger: 'blur'}
                ],
                // receiverName: [
                //     {required: true, message: this.$t('p_postagedInfo.message.collectPerson'), trigger: 'blur'},
                //     {max: 100, message: this.$t('p_postagedInfo.message.tooLong') + 100, trigger: 'blur'}
                // ],
                // receiverAddress: [
                //     {required: true, message: this.$t('p_postagedInfo.message.collectAddress'), trigger: 'blur'},
                //     {max: 100, message: this.$t('p_postagedInfo.message.tooLong') + 100, trigger: 'blur'}
                // ],
                // receiverPhone: [
                //     {required: true, message: this.$t('p_postagedInfo.message.collectPhone'), trigger: 'blur'},
                //     // { pattern: /^1[3-9]\d{9}$/, message: this.$t('p_postagedInfo.message.errPhone') },
                // ],
            }
        },
    },
    methods: {
        autoOriginal(){
            if (this.printApplyForm.type === 1) {
                this.isNumReadOnly = true;
                if (this.printApplyForm.blId) {
                    this.blData.forEach(item => {
                        if(item.id === this.printApplyForm.blId){
                            this.printApplyForm.applyOriginalNumber = item.NoOfOriginal;
                            // this.printApplyForm.applyCopyNumber = item.NoOfOriginal;
                        }
                    });
                }
            }else{
                this.isNumReadOnly = false;
            }
        },
        // autoPid(){
        //     if(this.printApplyForm.pid){
        //         this.printerData.forEach(item => {
        //             if(item.pid === this.printApplyForm.pid){

        //             }
        //         });
        //     }
        // },
        init() {
            // 取数据判断是走表单，还是PDF.修改showBillLading和showPdf(互斥)
            this.conditionData = this.$routerUtil.getParam();
            // this.printApplyForm = this.conditionData.row;
            const param = {};
            param.rcSignatureConfirmResult = 1;
            param.scSignatureConfirmResult = 1;
            param.signSignatureConfirmResult = 1;
            const blNos = [];
            this.$axios.get('/api/billOfLadings/billOfLadingManage', {params: param}).then(response => {
                response.data.resultData.rows.forEach(item => {
                    if(blNos.indexOf(item.blNo) === -1){
                        this.blData.push(item);
                        blNos.push(item.blNo);
                    }
                });
            });
        },
        submitForm(formName) {
            console.log(this.$refs[formName], this.$refs);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.printApplyForm.applyOriginalNumber <= 0 && this.printApplyForm.applyCopyNumber <=0){
                        this.$message({
                            message: this.$t('s_printApplyManage.message.applyNumberZero'),
                            type: 'warning',
                            center: true
                        });
                        return;
                    }
                    this.$axios.post('api/customerCompay/insertprintApply', this.printApplyForm).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.doCancel();
                        }
                        this.$message({
                            message: this.$t(response.data.message),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }
            });
        },
        doCancel() {
            this.$routerUtil.setParam(this.conditionData.searchForm);
            this.$router.push('PrintApplyManage');
        },
        // 获取出单费信息，判断支付类型 如果余额不足则提示，但不影响其操作
        getBillCostInfo() {
            this.checkResObject.checkRes = null;
            const billId = this.printApplyForm.blId;
            const applyType = this.printApplyForm.type;
            if (billId && applyType) {
                this.$axios.get('/api/customerCompay/checkbillcostinfo/' + billId + "/" + applyType).then(response => {
                    if (response.data.status === '1') {
                        this.checkResObject = response.data.resultData;
                        // 校验未通过
                        if (this.checkResObject.checkRes !== '1') {
                            if (!this.checkResObject.accountBalance) {
                                this.checkResMessage = this.$t('s_printApply.billFeeCompanyMoneyIsNull');
                                return;
                            }
                            if (!this.checkResObject.cost) {
                                this.checkResMessage = this.$t('s_printApply.billFeeIsNull');
                                return;
                            }
                            this.costMoney = this.checkResObject.cost;
                            this.accountBalance = this.checkResObject.accountBalance;
                            this.checkResMessage = this.$t('s_printApply.accountBalance/cost')+ "\u3000\u3000" + this.accountBalance  + "/" + this.costMoney +
                                "\u3000" + this.$t('s_printApply.insufficientBalance')
                        }
                    } else {
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    }
                }).catch(e => {
                    console.log(e);
                    this.$message({
                        message: this.$t('common.message.operateFail'),
                        type: 'error',
                        center: true
                    });
                });
            }
        },
        // 2021-02-03 根据提单id获取出单费支付公司
        getSendBillFeeCompanyName(billId) {
            this.blData.forEach(item => {
                if(item.id === billId){
                    this.sendBillFeeCompanyName = item.sendBillFeeCompanyName;

                    this.$axios.get('/api/print/getPrinters/' + billId).then(response => {
                        console.log(response.data.resultData)
                        this.printerData = response.data.resultData
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    });
                }
            });
        }
    }
}
